import { FormulaExecutable } from 'src/utils/columns/customColumnUtils';
import {
  Event,
  EventAttributes,
  OnSaleEventMetrics,
  Performer,
  Venue,
} from 'src/WebApiController';

export type OnSaleEventWithMetrics = {
  event: Event;
  eventAttributes?: EventAttributes | null;
  performer?: Performer;
  venue?: Venue;
  metrics?: OnSaleEventMetrics;
};

export enum OnSaleEventTableColumnId {
  Checkbox = 'checkbox',
  Event = 'event',
  InferredPrimary = 'inferredPrimary',
  Venue = 'venue',
  Capacity = 'capacity',
  Location = 'location',
  OnSaleDate = 'onSaleDate',
  Date = 'date',
  RawPreSaleDate = 'rawPreSaleDate',
  ListingCount = 'listingCount',
  TicketCount = 'ticketCount',
  UnitNetProceedsMin = 'unitNetProceedsMin',
  UnitNetProceedsP25 = 'unitNetProceedsP25',
  UnitNetProceedsP50 = 'unitNetProceedsP50',
  RecentVisits = 'recentVisits',
  VisitsLastHour = 'visitsLastHour',
  VisitsLastDay = 'visitsLastDay',
  VisitsLast3Days = 'visitsLast3Days',
  VisitsLast7Days = 'visitsLast7Days',
  TransactionsLastHour = 'transactionsLastHour',
  TransactionsLastDay = 'transactionsLastDay',
  TransactionsLast3Days = 'transactionsLast3Days',
  TransactionsLast7Days = 'transactionsLast7Days',
  Action = 'action',
}

export enum OnSaleEventFormulaFields {
  listingCount = 'listingCount',
  ticketCount = 'ticketCount',
  unitNetProceedsMin = 'unitNetProceedsMin',
  unitNetProceedsP25 = 'unitNetProceedsP25',
  unitNetProceedsP50 = 'unitNetProceedsP50',
}

export type CustomOnSaleEventColumn = {
  id: string;
  /**
   * Display name
   */
  name: string;
  /**
   * Formula that contains field names that can be interpolated and
   * evaluated using `evaluateFormula`.
   */
  formula: FormulaExecutable;
  /**
   * List of SalesTableColumnId that this column needs value from
   */
  dependency: OnSaleEventTableColumnId[];
};
